(() => {
  const url = new URL(window.location.href);
  const rawCode =
    url.searchParams.get('discount') ||
    url.searchParams.get('promo') ||
    url.searchParams.get('code');

  if (!rawCode || /\/cart\/?$/.test(url.pathname)) return;

  const discountCode = rawCode.trim().toUpperCase();
  if (!discountCode || discountCode.length > 255) return;

  const cleanUrl = new URL(url);
  cleanUrl.searchParams.delete('discount');
  cleanUrl.searchParams.delete('promo');
  cleanUrl.searchParams.delete('code');

  const root = window.Shopify?.routes?.root || '/';

  fetch(`${root}cart/update.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({ discount: discountCode }),
  })
    .then((response) => {
      if (!response.ok) throw new Error('Discount update failed');
      return response.json();
    })
    .then((cart) => {
      const applied = Array.isArray(cart.discount_codes)
        ? cart.discount_codes.some(
            (discount) =>
              discount.code?.toUpperCase() === discountCode && discount.applicable !== false
          )
        : true;

      if (!applied) return;
      window.history.replaceState({}, '', cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
      document.dispatchEvent(
        new CustomEvent('sayuki:discount-updated', {
          detail: { code: discountCode, cart },
        })
      );
    })
    .catch(() => {});
})();